import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "upload",
  class: "my-3 card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = {
  id: "upload-form",
  enctype: "multipart/form-data",
  method: "POST"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  id: "fileinput",
  style: {"display":"none"},
  type: "hidden",
  name: "MAX_FILE_SIZE",
  value: "50000000"
}, null, -1)
const _hoisted_6 = ["accept"]
const _hoisted_7 = ["value"]

import { ref } from "vue";
import axios from "axios";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
// import { t } from '../../../lang/Localize';
import { SessionUser } from "../../../utils/SessionUser";
import { UserFileImpl } from "../../../utils/UserFile";
import { translation } from "../../../lang/Translation";

interface Prop {
  onUpload: (fileName: string) => Promise<void>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploadSection',
  props: {
    onUpload: null
  },
  setup(__props: any) {

const props = __props as {
  onUpload: (fileName: string) => Promise<void>;
};


const t = translation;
const progress = ref(0);
const acceptExtentions = UserFileImpl.acceptExtentions;

/**
 * プログレスバーの進行
 */
const onUpload = (e) => (progress.value = Math.floor((e.loaded * 100) / e.total));
const sizeOf = (bytes:number ) => {
  if (bytes === 0) return "0.00 B"; 
  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes/Math.pow(1024, e)).toFixed(2)+' '+' KMGTP'.charAt(e)+'B';
}
/**
 * アップロード
 */
const upload = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const files = target.files[0];
  const size =  files.size;
  MessageDialog.info( `ファイルアップロードを開始しました。サイズ:${sizeOf(size)}` )
  const formData = new FormData();
  formData.append("userfile", files); // サーバーサイドの[user_assets_api.ts->uploadMultの名前と合わせる]

  const url = new URL(location.href);
  url.pathname = `/webapi/file/fileupload_api`;
  url.searchParams.append("user_id", `${SessionUser.instance.userId}`);
  url.searchParams.append("token", SessionUser.instance.token);

  try{
    const response = await axios.post(url.toString(), formData, {
      onUploadProgress: onUpload,
    });

    progress.value = 0;
    const fileName = response.data.Key;
    MessageDialog.info(`${fileName}${t.to("をアップロードしました", "uploaded")}`);
    await props.onUpload(fileName);
  }catch(e){
    console.error(e);
    MessageDialog.error(`ファイルアップロードでエラーが発生しました。`);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(t).to("アップロードするファイルを選択", "select_upload")), 1),
      _createElementVNode("form", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("input", {
          id: "userfile",
          name: "userfile",
          class: "form-control",
          type: "file",
          accept: _unref(acceptExtentions),
          onChange: upload
        }, null, 40, _hoisted_6),
        _createElementVNode("p", null, _toDisplayString(_unref(t).to("対応する拡張子", "accept_extentions")) + "：" + _toDisplayString(_unref(acceptExtentions)), 1),
        _createElementVNode("progress", {
          id: "upload_progress",
          class: "d-block w-100",
          value: progress.value,
          max: "100"
        }, null, 8, _hoisted_7)
      ])
    ])
  ]))
}
}

})